import { Injectable } from '@angular/core'
import { UserGroupPermissionId } from '@ftr/contracts/api/user-group'
import { Uuid } from '@ftr/contracts/type/shared'
import { Store } from '@ngxs/store'
import { Observable, map } from 'rxjs'
import { UserState } from '../../store'

@Injectable({
  providedIn: 'root',
})
export class PermissionsStoreService {
  constructor(private store: Store) {}

  getEnabledPermissions(courtSystemId: Uuid): Observable<Set<UserGroupPermissionId>> {
    return this.store
      .selectOnce(UserState.getEnabledPermissions)
      .pipe(map(fn => fn(courtSystemId)))
      .pipe(map(permissions => new Set(permissions.filter(x => x.isEnabled).map(x => x.id))))
  }
}
